import qs from "qs";
import {apiVoissa} from "../../libs/api";


export const fetchOffers = (query = {}, config = {}) => apiVoissa.get(`/offers?${qs.stringify(query)}`, config);
export const fetchOfferFormData = (offerId = {}, config = {}) => apiVoissa.post(`/offers/${offerId}/formdata`, config);

export const OFFERS = `offers`;